var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7197 3.96973C11.0126 3.67683 11.4874 3.67683 11.7803 3.96973L16.2803 8.46973C16.3364 8.52585 16.3785 8.5903 16.4131 8.65723C16.4227 8.67583 16.4343 8.69342 16.4424 8.71289C16.4631 8.7629 16.4779 8.81458 16.4873 8.86719C16.495 8.91033 16.5 8.95464 16.5 9C16.5 9.04472 16.4948 9.0883 16.4873 9.13086C16.4779 9.18382 16.4632 9.23579 16.4424 9.28613C16.4343 9.30562 16.4227 9.32318 16.4131 9.3418C16.3784 9.40898 16.3366 9.47396 16.2803 9.53027L11.7803 14.0303C11.4874 14.3231 11.0126 14.3231 10.7197 14.0303C10.4268 13.7374 10.4269 13.2626 10.7197 12.9697L13.9395 9.75H2.25C1.83581 9.75 1.50003 9.41418 1.5 9C1.5 8.58579 1.83579 8.25 2.25 8.25H13.9395L10.7197 5.03027C10.4268 4.7374 10.4269 4.26262 10.7197 3.96973Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f7a801d9647b6acc71d3b86ffd752e09.svg";
export { ForwardRef as ReactComponent };